import { Component } from '@angular/core';

@Component({
  selector: 'btn-content-facebook',
  templateUrl: './btn-content-facebook.component.html',
  styleUrls: ['./btn-content-facebook.component.scss']
})
export class BtnContentFacebookComponent {
}
